module.exports = __webpack_public_path__ + "static/media/back.376ed483.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assets/back.svg
// module id = 6
// module chunks = 1